import React from "react";
import ReactDOM from "react-dom/client";
import store from "./redux/store";
import { Provider } from "react-redux";
import "./index.css";
import "./v4/theme/v4.css";
import App from "./App";
import { BrandProvider } from "./context/BrandContext";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { watchLegacyFont } from "./utils/legacyFonts";

// RISEMN one page site (REACT_APP_BRAND=risemn, src/risemn): its own root, no
// router, no admin, no brand config fetch, no service worker. The brand is
// fixed at build time, so webpack folds this constant and the DJ RISE build
// drops the RISEMN branch (and its chunk).
// (Written inline each time, not through a variable: webpack only folds a
// literal comparison.)
const RisemnApp = process.env.REACT_APP_BRAND === "risemn" ? React.lazy(() => import("./risemn/RisemnApp")) : null;

// Montserrat only on the old-look pages (not html.v4), never blocking the
// first paint. RISEMN does not use it.
if (process.env.REACT_APP_BRAND !== "risemn") {
  watchLegacyFont();
}

// Ensure React is available globally (helps with context in Safari)
if (typeof window !== "undefined") {
  window.React = React;
}

// Initialize app with error boundary
const AppWithProviders = () => {
  return (
    <React.StrictMode>
      <Provider store={store}>
        <BrandProvider>
          <script
            dangerouslySetInnerHTML={{
              __html: `window.__API_BASE_URL = ${JSON.stringify(
                process.env.REACT_APP_BACKEND_URL || "http://localhost:4040"
              )};`,
            }}
          />
          <App />
        </BrandProvider>
      </Provider>
    </React.StrictMode>
  );
};

// Create root and render
const root = ReactDOM.createRoot(document.getElementById("root"));

// Render with error handling
if (process.env.REACT_APP_BRAND === "risemn") {
  root.render(
    <React.StrictMode>
      <React.Suspense fallback={null}>
        <RisemnApp />
      </React.Suspense>
    </React.StrictMode>
  );
} else {
  try {
    root.render(<AppWithProviders />);
  } catch (error) {
    console.error("Render error:", error);
    // Fallback render without StrictMode if error occurs
    root.render(
      <Provider store={store}>
        <App />
      </Provider>
    );
  }
}

// Precaches the app shell so reloads are instant and work offline. Production
// only; see serviceWorkerRegistration.js for the update/reload strategy.
serviceWorkerRegistration.register();
